<h4 class="header bold">Switch Shows</h4>
<div *ngFor="let show of availableShows$ | async">
  <ion-item button (click)="selectShow(show)" lines="none">
    <ion-icon *ngIf="selectedShowID === show.showID" src="/assets/icons/24px/check.svg"></ion-icon>
    <img [src]="show.showImg" />
    <h5 class="bold">{{ show.showName }}</h5>
  </ion-item>
</div>
